import { useState } from 'react'
import { HIGHLIGHT_COLORS } from '../hooks/useHighlights'
import type { DbHighlight } from '../lib/supabase'

interface Props {
  highlight: DbHighlight
  onUpdate: (updates: { color?: string; note?: string | null }) => void
  onDelete: () => void
  onClose: () => void
}

export function HighlightDetail({
  highlight,
  onUpdate,
  onDelete,
  onClose,
}: Props) {
  const [note, setNote] = useState(highlight.note || '')
  const [color, setColor] = useState(highlight.color)
  const [confirmDelete, setConfirmDelete] = useState(false)

  const handleSave = () => {
    onUpdate({
      color,
      note: note.trim() || null,
    })
    onClose()
  }

  const handleDelete = () => {
    if (confirmDelete) {
      onDelete()
      onClose()
    } else {
      setConfirmDelete(true)
      setTimeout(() => setConfirmDelete(false), 3000)
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="highlight-detail-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Edit Highlight</h3>
          <button className="close-btn" onClick={onClose}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div className="highlight-preview" style={{ backgroundColor: color }}>
          "{highlight.text_content}"
        </div>

        <div className="color-picker">
          <label>Color</label>
          <div className="color-options">
            {HIGHLIGHT_COLORS.map((c) => (
              <button
                key={c.value}
                className={`color-option ${
                  color === c.value ? 'selected' : ''
                }`}
                style={{ backgroundColor: c.value }}
                onClick={() => setColor(c.value)}
                title={c.name}
              />
            ))}
          </div>
        </div>

        <div className="note-section">
          <label htmlFor="highlight-note">Note (optional)</label>
          <textarea
            id="highlight-note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Add your thoughts..."
            rows={3}
          />
        </div>

        <div className="modal-actions">
          <button
            className={`delete-btn ${confirmDelete ? 'confirm' : ''}`}
            onClick={handleDelete}
          >
            {confirmDelete ? 'Confirm Delete' : 'Delete'}
          </button>
          <div className="right-actions">
            <button className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
            <button className="save-btn" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
